import { z } from 'zod'

/**
 * ProjectFolder リソースの Zod スキーマ。
 *
 * 1階層の整理用フォルダ。共有・削除・容量の単位にはしない。
 * 関連: packages/db/prisma/schema.prisma の ProjectFolder model
 */

export const ProjectFolderSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})
export type ProjectFolder = z.infer<typeof ProjectFolderSchema>

export const FolderListItemSchema = ProjectFolderSchema.extend({
  activeProjectCount: z.number().int().nonnegative(),
})
export type FolderListItem = z.infer<typeof FolderListItemSchema>

// ----- Path parameters -----

export const FolderIdParamsSchema = z.object({
  id: z.string().uuid(),
})
export type FolderIdParams = z.infer<typeof FolderIdParamsSchema>

// ----- Folder name -----

/**
 * フォルダ名の正規化（一意比較・保存の前処理）。
 * - NFKC（全角英数・全角スペースなどを揃える）
 * - 前後空白除去
 * - 連続空白を半角スペース 1 つに
 */
export function normalizeFolderName(raw: string): string {
  return raw.normalize('NFKC').trim().replace(/\s+/g, ' ')
}

/** ユーザー向け: 同名フォルダがあるときのメッセージ */
export const FOLDER_NAME_CONFLICT_MESSAGE =
  '同じ名前のフォルダがすでにあります。別の名前にしてください。'

const FolderNameInputSchema = z
  .string()
  .min(1, 'name は必須です')
  .max(100, 'name は 100 文字以内にしてください')
  .transform(normalizeFolderName)
  .pipe(z.string().min(1, 'name は必須です').max(100, 'name は 100 文字以内にしてください'))

// ----- Input bodies -----

export const CreateFolderInputSchema = z.object({
  name: FolderNameInputSchema,
})
export type CreateFolderInput = z.infer<typeof CreateFolderInputSchema>

export const UpdateFolderInputSchema = z.object({
  name: FolderNameInputSchema,
})
export type UpdateFolderInput = z.infer<typeof UpdateFolderInputSchema>

// ----- List response -----

export const ListFoldersResultSchema = z.object({
  items: z.array(FolderListItemSchema),
})
export type ListFoldersResult = z.infer<typeof ListFoldersResultSchema>
